/*
Detect sharpness of the image uploaded or on browser/kiosk
*/

var WIDTH = 600, HEIGHT= 400;

function sharpness(variance, max) {
   /**
   * Predicts whether a picture is blurred, likely blurred, or sharp.
   *
   * @param variance - the variance over the pixel values of the Laplace-filtered picture
   * @param max - the maximum value over the pixels of the Laplace-filtered picture
   
   * @returns `-1` for blurred, `0` for likely blurred, and `1` for sharp.
   */

  // scaling: scale (scaler.scale_)
  var s1 = 0.01114463;
  var s2 = 0.60951684;
  
  // scaling: mean (scaler.mean_)
  var u1 = 0.010302;
  var u2 = 0.96132364;
  
  // classifier: weights (clf.coef_[0])
  var w1 = 2.84434861;
  var w2 = 2.59967242;
  
  // classifier: intercept (clf.intercept_)
  var i = 0.42628533;
  
  // standardize
  var std1 = (variance - u1) / s1;
  var std2 = (max - u2) / s2;
  
  // predict

  var y = (w1 * std1 + w2 * std2) + i; 
  
  // classify
  if (y < -1) { 
    return -1; // blurred
  } else if (y < 0) {
    return 0; // likely blurred
  } else {
    return 1; // not blurred
  }
}

function predictSharpness(filter, img) {
  var prediction;
  var pixels = filterImage(filter, img)
  var variance = getVariance(pixels)
  var max = getMax(pixels)
  var mean = getMean(pixels)
  var min = getMin(pixels)
  console.log('VARIANCE=' ,variance, 'MAX=', max, 'MIN=', min, 'MEAN =', mean )
  if (variance !=0 && max !=0) {
    prediction = sharpness(variance, max) 
  }
  return prediction
}

function getVariance(pixels) {
  var data = pixels.data;
  var mean;
  var variance = 0;
  mean = getMean(pixels) 

  for (var i =0; i< data.length; i+=1) {
      variance += Math.pow((data[i]-mean), 2)
  }
  variance /= (data.length)
  return variance
}

function getMax(pixels) {
  var data = pixels.data
  var max = 0
  for (var i = 0; i < data.length; i+=1) {
    if (max < data[i])
      max = data[i]
  }
  return max
}

function getMin(pixels) {
  var data = pixels.data
  var min = Infinity
  for (var i = 0; i < data.length; i+=1) {
    if (min > data[i])
      min = data[i]
  }
  return min
}

function getMean(pixels) {
  var data = pixels.data
  var sum = 0
  for (var i = 0; i < data.length; i+=1) {
      sum += data[i]
  }
  var N = data.length
  return sum/N
}


function getPixels(img) {
    img.crossOrigin = "Anonymous"
    var canvas = getCanvas(img.width, img.height);
    var ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0, 600, 400);   
    return ctx.getImageData(0,0,600,400);
}

function getCanvas(w,h) {
    var c = document.createElement('canvas');
    c.width = w;
    c.height = h;
    return c;
}

function filterImage(filter, image, var_args) {
    var args = [getPixels(image)];
    for (var i=2; i<arguments.length; i++) {
      args.push(arguments[i]);
    }
    return filter.apply(null, args);
};

function rgb2gray(pixels) {//Y = 0.2125 R + 0.7154 G + 0.0721 B
    var pixelArr = pixels.data
    var pixelLength = pixelArr.length
    var n = Math.floor(pixelLength/(WIDTH*HEIGHT))
    var out = new Float64Array(WIDTH*HEIGHT)
    for (var i = 0; i < out.length; i+=1) {
        var value = 0.21250*pixelArr[n*i]/255 + 0.71540*pixelArr[n*i+1]/255 + 0.07210*pixelArr[n*i+2]/255
        out[i] = value 
    }
    return out
}


function convoluteFloat64(pixels, weights, opaque) {
    var side = Math.round(Math.sqrt(weights.length));
    var halfSide = Math.floor(side/2);
    var src = pixels.data;
    var sw = pixels.width;
    var sh = pixels.height;

    var w = sw;
    var h = sh;
    var output = {
      width: w, height: h, data: new Float64Array(w*h)
    };
    var dst = output.data;

    for (var y=0; y<h; y++) {
      for (var x=0; x<w; x++) {
        var sy = y;
        var sx = x;
        var dstOff = (y*w+x);
        var r=0, g=0, b=0, a=0;
        for (var cy=0; cy<side; cy++) {
          for (var cx=0; cx<side; cx++) {
            var scy = Math.min(sh-1, Math.max(0, sy + cy - halfSide));
            var scx = Math.min(sw-1, Math.max(0, sx + cx - halfSide));
            var srcOff = (scy*sw+scx);
            var wt = weights[cy*side+cx];
            r += src[srcOff] * wt;
          }
        }
        dst[dstOff] = r;
      }
    }
    return output;
}


function laplacian(px) {
    var pxgray = rgb2gray(px)

    px = {data:pxgray, width:WIDTH, height:HEIGHT}

    var vertical = convoluteFloat64(px,
      [0, -1, 0,
       -1, 4, -1,
       0, -1, 0]); //laplace kernel for edge detection

    var id = {
      width: px.width, height: px.height, data: new Float64Array(px.width*px.height)
    }; 

    for (var i=0; i<id.data.length; i+=1) {
      var v = vertical.data[i]
      id.data[i] = v;
    }

    return id;
  };


module.exports = { 
    predictSharpness, 
    filterImage, 
    getPixels,
    filters: { 
      laplacian
    }
}

